import { initTdx } from '../../../init/sdkTdx';
import { tdx_request, tdx_response } from "../../../tdx_proto/bundle";
import { getConnectionPool } from '../../../core/connectionPool';
import { hashString } from '../../../utils/hash';

export async function GetRemovedTeamsFromLogs(
    fromTime: number,
    toTime: number
): Promise<string[]> {
    const pool = await getConnectionPool();
    const pin = await hashString(pool.getPin());
    const data = pool.getToken();
    const client = await initTdx();
    let times = 10;
    while (client.is_open() == false && times >= 0) {
        times -= 1;
        await new Promise(resolve => setTimeout(resolve, 1000));
    }
    if (times < 0) throw new Error("Connection Failed. Please try again.");

    const req = tdx_request.Request.create({
        getRemovedTeamsFromLogs: tdx_request.GetRemovedTeamsFromLogs.create({ pin, data, fromTime, toTime })
    });

    try {
        const res = await client.sendAndWait(req);
        client.close();
        if (res?.getRemovedTeamsFromLogs?.status != tdx_response.Status.SUCCESS) {
            throw Error(`failed to get removed teams from logs ${res?.getRemovedTeamsFromLogs?.status}`);
        }
        return res?.getRemovedTeamsFromLogs?.teamNames || [];
    } catch (err) {
        client.close();
        throw Error('Error in GetRemovedTeamsFromLogs request: ' + err);
    }
}

export async function GetRemovedUsersFromLogs(
    fromTime: number,
    toTime: number
): Promise<string[]> {
    const pool = await getConnectionPool();
    const pin = await hashString(pool.getPin());
    const data = pool.getToken();
    const client = await initTdx();
    let times = 10;
    while (client.is_open() == false && times >= 0) {
        times -= 1;
        await new Promise(resolve => setTimeout(resolve, 1000));
    }
    if (times < 0) throw new Error("Connection Failed. Please try again.");

    const req = tdx_request.Request.create({
        getRemovedUsersFromLogs: tdx_request.GetRemovedUsersFromLogs.create({ pin, data, fromTime, toTime })
    });

    try {
        const res = await client.sendAndWait(req);
        client.close();
        if (res?.getRemovedUsersFromLogs?.status != tdx_response.Status.SUCCESS) {
            throw Error(`failed to get removed users from logs ${res?.getRemovedUsersFromLogs?.status}`);
        }
        return res?.getRemovedUsersFromLogs?.email || [];
    } catch (err) {
        client.close();
        throw Error('Error in GetRemovedUsersFromLogs request: ' + err);
    }
}

export async function UserActivityTimeline(
    email: string,
    fromTime: number,
    toTime: number
): Promise<tdx_response.User_ActivityTimeline.IItem[]> {
    const pool = await getConnectionPool();
    const pin = await hashString(pool.getPin());
    const data = pool.getToken();
    const client = await initTdx();
    let times = 10;
    while (client.is_open() == false && times >= 0) {
        times -= 1;
        await new Promise(resolve => setTimeout(resolve, 1000));
    }
    if (times < 0) throw new Error("Connection Failed. Please try again.");

    const req = tdx_request.Request.create({
        user_ActivityTimeline: tdx_request.User_ActivityTimeline.create({ pin, data, fromTime, toTime, email })
    });

    try {
        const res = await client.sendAndWait(req);
        client.close();
        if (res?.userActivityTimeline?.status != tdx_response.Status.SUCCESS) {
            throw Error(`failed to get user activity timeline ${res?.userActivityTimeline?.status}`);
        }
        return res?.userActivityTimeline?.items || [];
    } catch (err) {
        client.close();
        throw Error('Error in UserActivityTimeline request: ' + err);
    }
}

export async function UserCountriesAccessedFrom(
    email: string,
    fromTime: number,
    toTime: number
): Promise<tdx_response.User_CountriesAccessedFrom.IItem[]> {
    const pool = await getConnectionPool();
    const pin = await hashString(pool.getPin());
    const data = pool.getToken();
    const client = await initTdx();
    let times = 10;
    while (client.is_open() == false && times >= 0) {
        times -= 1;
        await new Promise(resolve => setTimeout(resolve, 1000));
    }
    if (times < 0) throw new Error("Connection Failed. Please try again.");

    const req = tdx_request.Request.create({
        user_CountriesAccessedFrom: tdx_request.User_CountriesAccessedFrom.create({ pin, data, fromTime, toTime, email })
    });

    try {
        const res = await client.sendAndWait(req);
        client.close();
        if (res?.user_CountriesAccessedFrom?.status != tdx_response.Status.SUCCESS) {
            throw Error(`failed to get user countries accessed from ${res?.user_CountriesAccessedFrom?.status}`);
        }
        return res?.user_CountriesAccessedFrom?.items || [];
    } catch (err) {
        client.close();
        throw Error('Error in UserCountriesAccessedFrom request: ' + err);
    }
}

export async function UserOpCount(
    email: string,
    fromTime: number,
    toTime: number
): Promise<tdx_response.User_OpCount.IItem[]> {
    const pool = await getConnectionPool();
    const pin = await hashString(pool.getPin());
    const data = pool.getToken();
    const client = await initTdx();
    let times = 10;
    while (client.is_open() == false && times >= 0) {
        times -= 1;
        await new Promise(resolve => setTimeout(resolve, 1000));
    }
    if (times < 0) throw new Error("Connection Failed. Please try again.");

    const req = tdx_request.Request.create({
        user_OpCount: tdx_request.User_OpCount.create({ pin, data, fromTime, toTime, email })
    });

    try {
        const res = await client.sendAndWait(req);
        client.close();
        if (res?.user_OpCount?.status != tdx_response.Status.SUCCESS) {
            throw Error(`failed to get user op count ${res?.user_OpCount?.status}`);
        }
        return res?.user_OpCount?.items || [];
    } catch (err) {
        client.close();
        throw Error('Error in UserOpCount request: ' + err);
    }
}

export async function UserWriteActivity(
    email: string,
    fromTime: number,
    toTime: number
): Promise<tdx_response.User_WriteActivity.IItem[]> {
    const pool = await getConnectionPool();
    const pin = await hashString(pool.getPin());
    const data = pool.getToken();
    const client = await initTdx();
    let times = 10;
    while (client.is_open() == false && times >= 0) {
        times -= 1;
        await new Promise(resolve => setTimeout(resolve, 1000));
    }
    if (times < 0) throw new Error("Connection Failed. Please try again.");

    const req = tdx_request.Request.create({
        user_WriteActivity: tdx_request.User_WriteActivity.create({ pin, data, fromTime, toTime, email })
    });

    try {
        const res = await client.sendAndWait(req);
        client.close();
        if (res?.user_WriteActivity?.status != tdx_response.Status.SUCCESS) {
            throw Error(`failed to get user write activity ${res?.user_WriteActivity?.status}`);
        }
        return res?.user_WriteActivity?.items || [];
    } catch (err) {
        client.close();
        throw Error('Error in UserWriteActivity request: ' + err);
    }
}

export async function UserStorageBreakdown(
    email: string,
    fromTime: number,
    toTime: number
): Promise<tdx_response.User_StorageBreakdown.IItem[]> {
    const pool = await getConnectionPool();
    const pin = await hashString(pool.getPin());
    const data = pool.getToken();
    const client = await initTdx();
    let times = 10;
    while (client.is_open() == false && times >= 0) {
        times -= 1;
        await new Promise(resolve => setTimeout(resolve, 1000));
    }
    if (times < 0) throw new Error("Connection Failed. Please try again.");

    const req = tdx_request.Request.create({
        user_StorageBreakdown: tdx_request.User_StorageBreakdown.create({ pin, data, fromTime, toTime, email })
    });

    try {
        const res = await client.sendAndWait(req);
        client.close();
        if (res?.user_StorageBreakdown?.status != tdx_response.Status.SUCCESS) {
            throw Error(`failed to get user storage breakdown ${res?.user_StorageBreakdown?.status}`);
        }
        return res?.user_StorageBreakdown?.items || [];
    } catch (err) {
        client.close();
        throw Error('Error in UserStorageBreakdown request: ' + err);
    }
}

export async function UserFilesTouched(
    email: string,
    fromTime: number,
    toTime: number
): Promise<tdx_response.User_FilesTouched.IItem[]> {
    const pool = await getConnectionPool();
    const pin = await hashString(pool.getPin());
    const data = pool.getToken();
    const client = await initTdx();
    let times = 10;
    while (client.is_open() == false && times >= 0) {
        times -= 1;
        await new Promise(resolve => setTimeout(resolve, 1000));
    }
    if (times < 0) throw new Error("Connection Failed. Please try again.");

    const req = tdx_request.Request.create({
        user_FilesTouched: tdx_request.User_FilesTouched.create({ pin, data, fromTime, toTime, email })
    });

    try {
        const res = await client.sendAndWait(req);
        client.close();
        if (res?.user_FilesTouched?.status != tdx_response.Status.SUCCESS) {
            throw Error(`failed to get user files touched ${res?.user_FilesTouched?.status}`);
        }
        return res?.user_FilesTouched?.items || [];
    } catch (err) {
        client.close();
        throw Error('Error in UserFilesTouched request: ' + err);
    }
}

export async function UserSharingActions(
    email: string,
    fromTime: number,
    toTime: number
): Promise<any[]> {
    const pool = await getConnectionPool();
    const pin = await hashString(pool.getPin());
    const data = pool.getToken();
    const client = await initTdx();
    let times = 10;
    while (client.is_open() == false && times >= 0) {
        times -= 1;
        await new Promise(resolve => setTimeout(resolve, 1000));
    }
    if (times < 0) throw new Error("Connection Failed. Please try again.");

    const req = tdx_request.Request.create({
        user_SharingActions: tdx_request.User_SharingActions.create({ pin, data, fromTime, toTime, email })
    });

    try {
        const res = await client.sendAndWait(req);
        client.close();
        if (res?.user_SharingActions?.status != tdx_response.Status.SUCCESS) {
            throw Error(`failed to get user sharing actions ${res?.user_SharingActions?.status}`);
        }
        return res?.user_SharingActions?.items || [];
    } catch (err) {
        client.close();
        throw Error('Error in UserSharingActions request: ' + err);
    }
}

export async function UserPermissionRecieved(
    email: string,
    fromTime: number,
    toTime: number
): Promise<{ roles: string[]; teams: string[] }> {
    const pool = await getConnectionPool();
    const pin = await hashString(pool.getPin());
    const data = pool.getToken();
    const client = await initTdx();
    let times = 10;
    while (client.is_open() == false && times >= 0) {
        times -= 1;
        await new Promise(resolve => setTimeout(resolve, 1000));
    }
    if (times < 0) throw new Error("Connection Failed. Please try again.");

    const req = tdx_request.Request.create({
        user_PermissionRecieved: tdx_request.User_PermissionRecieved.create({ pin, data, fromTime, toTime, email })
    });

    try {
        const res = await client.sendAndWait(req);
        client.close();
        if (res?.user_PermissionRecieved?.status != tdx_response.Status.SUCCESS) {
            throw Error(`failed to get user permission recieved ${res?.user_PermissionRecieved?.status}`);
        }
        return {
            roles: res?.user_PermissionRecieved?.roles || [],
            teams: res?.user_PermissionRecieved?.teams || []
        };
    } catch (err) {
        client.close();
        throw Error('Error in UserPermissionRecieved request: ' + err);
    }
}

export async function UserDeniedAttempts(
    email: string,
    fromTime: number,
    toTime: number
): Promise<tdx_response.User_DeniedAttempts.IItem[]> {
    const pool = await getConnectionPool();
    const pin = await hashString(pool.getPin());
    const data = pool.getToken();
    const client = await initTdx();
    let times = 10;
    while (client.is_open() == false && times >= 0) {
        times -= 1;
        await new Promise(resolve => setTimeout(resolve, 1000));
    }
    if (times < 0) throw new Error("Connection Failed. Please try again.");

    const req = tdx_request.Request.create({
        user_DeniedAttempts: tdx_request.User_DeniedAttempts.create({ pin, data, fromTime, toTime, email })
    });

    try {
        const res = await client.sendAndWait(req);
        client.close();
        if (res?.user_DeniedAttempts?.status != tdx_response.Status.SUCCESS) {
            throw Error(`failed to get user denied attempts ${res?.user_DeniedAttempts?.status}`);
        }
        return res?.user_DeniedAttempts?.items || [];
    } catch (err) {
        client.close();
        throw Error('Error in UserDeniedAttempts request: ' + err);
    }
}

export async function UserRiskScore(
    email: string,
    fromTime: number,
    toTime: number
): Promise<tdx_response.User_RiskScore.IItem[]> {
    const pool = await getConnectionPool();
    const pin = await hashString(pool.getPin());
    const data = pool.getToken();
    const client = await initTdx();
    let times = 10;
    while (client.is_open() == false && times >= 0) {
        times -= 1;
        await new Promise(resolve => setTimeout(resolve, 1000));
    }
    if (times < 0) throw new Error("Connection Failed. Please try again.");

    const req = tdx_request.Request.create({
        user_RiskScore: tdx_request.User_RiskScore.create({ pin, data, fromTime, toTime, email })
    });

    try {
        const res = await client.sendAndWait(req);
        client.close();
        if (res?.user_RiskScore?.status != tdx_response.Status.SUCCESS) {
            throw Error(`failed to get user risk score ${res?.user_RiskScore?.status}`);
        }
        return res?.user_RiskScore?.items || [];
    } catch (err) {
        client.close();
        throw Error('Error in UserRiskScore request: ' + err);
    }
}

export async function UserTopContributingSignals(
    email: string,
    fromTime: number,
    toTime: number
): Promise<tdx_response.User_TopContributingSignals.IItem[]> {
    const pool = await getConnectionPool();
    const pin = await hashString(pool.getPin());
    const data = pool.getToken();
    const client = await initTdx();
    let times = 10;
    while (client.is_open() == false && times >= 0) {
        times -= 1;
        await new Promise(resolve => setTimeout(resolve, 1000));
    }
    if (times < 0) throw new Error("Connection Failed. Please try again.");

    const req = tdx_request.Request.create({
        user_TopContributingSignals: tdx_request.User_TopContributingSignals.create({ pin, data, fromTime, toTime, email })
    });

    try {
        const res = await client.sendAndWait(req);
        client.close();
        if (res?.user_TopContributingSignals?.status != tdx_response.Status.SUCCESS) {
            throw Error(`failed to get user top contributing signals ${res?.user_TopContributingSignals?.status}`);
        }
        return res?.user_TopContributingSignals?.items || [];
    } catch (err) {
        client.close();
        throw Error('Error in UserTopContributingSignals request: ' + err);
    }
}

export async function UserAnomalies(
    email: string,
    fromTime: number,
    toTime: number
): Promise<tdx_response.User_Anomalies.IItem[]> {
    const pool = await getConnectionPool();
    const pin = await hashString(pool.getPin());
    const data = pool.getToken();
    const client = await initTdx();
    let times = 10;
    while (client.is_open() == false && times >= 0) {
        times -= 1;
        await new Promise(resolve => setTimeout(resolve, 1000));
    }
    if (times < 0) throw new Error("Connection Failed. Please try again.");

    const req = tdx_request.Request.create({
        user_Anomalies: tdx_request.User_Anomalies.create({ pin, data, fromTime, toTime, email })
    });

    try {
        const res = await client.sendAndWait(req);
        client.close();
        if (res?.user_Anomalies?.status != tdx_response.Status.SUCCESS) {
            throw Error(`failed to get user anomalies ${res?.user_Anomalies?.status}`);
        }
        return res?.user_Anomalies?.items || [];
    } catch (err) {
        client.close();
        throw Error('Error in UserAnomalies request: ' + err);
    }
}

export async function UserOverview(
    email: string,
    fromTime: number,
    toTime: number
): Promise<tdx_response.User_Overview.IItem[]> {
    const pool = await getConnectionPool();
    const pin = await hashString(pool.getPin());
    const data = pool.getToken();
    const client = await initTdx();
    let times = 10;
    while (client.is_open() == false && times >= 0) {
        times -= 1;
        await new Promise(resolve => setTimeout(resolve, 1000));
    }
    if (times < 0) throw new Error("Connection Failed. Please try again.");

    const req = tdx_request.Request.create({
        user_Overview: tdx_request.User_Overview.create({ pin, data, fromTime, toTime, email })
    });

    try {
        const res = await client.sendAndWait(req);
        client.close();
        if (res?.user_Overview?.status != tdx_response.Status.SUCCESS) {
            throw Error(`failed to get user overview ${res?.user_Overview?.status}`);
        }
        return res?.user_Overview?.items || [];
    } catch (err) {
        client.close();
        throw Error('Error in UserOverview request: ' + err);
    }
}

export async function UserTimeHeatmap(
    email: string,
    fromTime: number,
    toTime: number
): Promise<tdx_response.User_TimeHeatmap.IItem[]> {
    const pool = await getConnectionPool();
    const pin = await hashString(pool.getPin());
    const data = pool.getToken();
    const client = await initTdx();
    let times = 10;
    while (client.is_open() == false && times >= 0) {
        times -= 1;
        await new Promise(resolve => setTimeout(resolve, 1000));
    }
    if (times < 0) throw new Error("Connection Failed. Please try again.");

    const req = tdx_request.Request.create({
        userTimeHeatmap: tdx_request.User_TimeHeatmap.create({ pin, data, fromTime, toTime, email })
    });

    try {
        const res = await client.sendAndWait(req);
        client.close();
        if (res?.userTimeHeatmap?.status != tdx_response.Status.SUCCESS) {
            throw Error(`failed to get user time heatmap ${res?.userTimeHeatmap?.status}`);
        }
        return res?.userTimeHeatmap?.items || [];
    } catch (err) {
        client.close();
        throw Error('Error in UserTimeHeatmap request: ' + err);
    }
}